import AccessDeniedText from "./AccessDeniedText";
import Footer from "./Footer";
import Header from "./Header";
import Container from '@mui/material/Container';

export default function AccessDenied() {
    return (
        <>
            <Header message={"Access Denied"} />
                <Container maxWidth={false}>
                    <AccessDeniedText />
                </Container>
            <Footer/>
        </>
    );
}